export const COIN_BALANCE_CHANGED = 'coin-balance-changed';

export const dispatchCoinBalanceChanged = () => {
  window.dispatchEvent(new CustomEvent(COIN_BALANCE_CHANGED));
};
